<div class="row">
    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/communication.webp" alt="Asesorías" width="42" height="42">
            </div>
            <div class="content">
                <h3>Asesoría personalizada</h3>
                <p>Ayuda inmediata por medio de nuestros <span>Canal de Whatsapp</span></p>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/dividend.webp" alt="Comisiones" width="42" height="42">
            </div>
            <div class="content">
                <h3>Comisiones preferenciales</h3>
                <p>Invierte, gana más pagando menos</p>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/mentorship.webp" alt="Mentorías" width="42" height="42">
            </div>
            <div class="content">
                <h3>Mentorías Personalizadas</h3>
                <p>Define tu estrategia con guía directa de nuestros expertos</p>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/backer.webp" alt="Referidos" width="42" height="42">
            </div>
            <div class="content">
                <h3>Programa Referidos</h3>
                <p>Gana beneficios invitando a otros.</p>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/reading.webp" alt="ebooks" width="42" height="42">
            </div>
            <div class="content">
                <h3>eBooks exclusivos</h3>
                <p>Aprende con recursos diseñados por nuestro equipo</p>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/chip.webp" alt="Gpt" width="42" height="42">
            </div>
            <div class="content">
                <h3>GPT Financiero exclusivo</h3>
                <p>Asesor virtual 24/7 con inteligencia artificial</p>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/classroom.webp" alt="Masterclass" width="42" height="42">
            </div>
            <div class="content">
                <h3>Masterclass mensuales</h3>
                <p>Sesiones con expertos del Mercado de Valores ecuatoriano, en vivo o grabadas.</p>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <div class="box">
            <div class="icon">
                <img src="assets/images/icons/discount.webp" alt="arrow right" width="42" height="42">
            </div>
            <div class="content">
                <h3>Descuentos en programas</h3>
                <p>Ahorra en nuestros programas de educación financiera</p>
            </div>
        </div>
    </div>
</div>
